export function setCDNCookies(cookieObj: any) {
    Object.entries(cookieObj).forEach(([key, value]) => {
        document.cookie = `${key}=${value}; path=/`;
    });
}
